angular.module('directives.dashboard').directive('wgtStockTransactionsPerSupplier', ['DashboardApiService',
        function (DashboardApiService) {
            return {
                templateUrl: 'directives/dashboard/widgets/wgtStockTransactionsPerSupplier/wgtStockTransactionsPerSupplier.tpl.html',
                link: function ($scope) {
                    $scope.isLoaded = false;
                    $scope.hasError = false;
                    $scope.loadWidget = function () {
                        DashboardApiService.getWidgetData($scope.item.name, $scope.item.setting)
                            .then(function (response) {
                                $scope.data = response.data;
                                $scope.isLoaded = true;
                                $scope.formatDate = function(inputDate) {
                                    var date = new Date(inputDate);
                                    var d = "";
                                    d += date.toISOString().split('T')[0];
                                    return d;
                                }
                            }, function (response) {
                                $scope.hasError = true;
                            });
                    };
                    $scope.loadWidget();
                }
            };
        }]
);